import OnSaleReportStatus from './LatestOnSalePropertyStatusReport';
import OnSaleStatusReportError from './LatestOnSalePropertyStatusReportError';
export default OnSaleReportStatus;
export { OnSaleStatusReportError };
